import base from "../../../base";

export default async function fetchTreeGameType(treeID) {
	const treeGameType = base.fetch(`trees/${treeID}/treeInfo/gameType`, { context: this });
	return treeGameType;
}
